<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="app名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-search-select-tag
            v-decorator="['appId', validatorRules.appId]"
            placeholder="请选择app" 
            dict="bus_common_manage_app,app_name,id"
            :disabled="disabledEdit"
          />
        </a-form-item>
        <a-form-item label="版本号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'appVersion', validatorRules.appVersion]" placeholder="请输入版本号"  :disabled="disabledEdit"  ></a-input>
        </a-form-item>
        <a-form-item label="下载地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'appAddress', validatorRules.appAddress]" placeholder="请输入下载地址"  :disabled="disabledEdit"  ></a-input>
        </a-form-item>
        <a-form-item label="状态 " :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag v-decorator="['status', validatorRules.status]"  :trigger-change="true" placeholder="请选择状态" dictCode="app_version_status" @change="statusChange"  />
        </a-form-item>
        <a-form-item label="强制更新" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag v-decorator="['hasForceUpdate', validatorRules.hasForceUpdate]"  :trigger-change="true" placeholder="请选择是否强制更新" dictCode="status_yes_no"  :disabled="disabledEdit"  />
        </a-form-item>
        <a-form-item label="发布内容" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'remarks', validatorRules.remarks]" placeholder="请输入发布内容"  :disabled="disabledEdit"  ></a-input>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDate from '@/components/jeecg/JDate'  
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  export default {
    name: "BusCommonManageAppVersionModal",
    components: { 
      JDate,JSearchSelectTag
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          appId: {rules: [
            {required: true, message: '请选择app!'},
          ]},
          appName:{rules: [
            {required: true, message: '请选择app!'},
          ]},
          appVersion: {rules: [
            {required: true, message: '请输入app版本!'},
          ]},
          appAddress: {rules: [
          ]},
          hasForceUpdate: {rules: [
            {required: true, message: '请选择是否强制更新!'},
          ]},
          status: {rules: [
            {required: true, message: '请选择app状态!'},
          ]},
          remarks: {rules: [
          ]},
        },
        url: {
          add: "/common/busCommonManageAppVersion/add",
          edit: "/common/busCommonManageAppVersion/edit",
        },
        disabledEdit:false,
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.statusChange(record.status)
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'appId','appName','appVersion','appAddress','hasForceUpdate','status','remarks'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      statusChange(value){
        if(!this.model.id){
          this.disabledEdit=false
          return
        }
        if(value&&value=='Publish'||value=='OffShelves'){
          this.disabledEdit=true
        }else{
          this.disabledEdit=false
        }
      }      
    }
  }
</script>